document.addEventListener("facet:update", function (event) {
  setTimeout(() => {
    if ($('.select2-custom-filters').length) {
      mountSelect2CustomFilters();
      console.log("Select2 opnieuw geïnitialiseerd na facet:update event met vertraging");
    }
  }, 2000); // Pas de vertragingstijd aan als nodig
});

$(document).ready(function () {
  

  $('body').on('click', '.main-brand-btn', function() {
    const searchUrl = $(this).data('search-url');
    const localSearchUrl = $(this).data('local-url');
    const btnText = $(this).find('a').text();
    
    // Destroy de huidige Select2 instance voor we nieuwe data laden
    
    // fetch(localSearchUrl)
    const selectTwoContainer = $('.select2__container');
    const loadingSpinner = $('.big-search__filters-loading-spinner');

    loadingSpinner.removeClass('hidden');
    selectTwoContainer.addClass('loading');

    console.log('test 0');
    fetch(searchUrl)
      .then(response => response.text())
      .then(html => {
        // console.log('test 1');
        parseHTML(html, btnText);
        loadingSpinner.addClass('hidden');
        selectTwoContainer.removeClass('loading');
      })
      .catch(error => {
        console.error('Fout bij ophalen:', error);
      }); 
    });


  if($('.select2-custom-filters').length){
    mountSelect2CustomFilters();
  }

  $('body').on('change', '.select2-custom-filters', function(){
    var selectedValue = $(this).val();

    const customFilterSearchInput = document.querySelector('.custom-filter-search');

    console.log('selectedValue', selectedValue);

    if(customFilterSearchInput){
      const existingValue = customFilterSearchInput.value;

      customFilterSearchInput.value = existingValue ? `${existingValue} ${selectedValue}` : selectedValue;
    }

    console.log('test2');

    const form = document.querySelector('.filter-form');
    $('.checkbox-container .checkbox').each(function () {
      if ($(this).val() === selectedValue) {
        $(this).prop('checked', true);
      }
    });

    // Trigger de formulier-logica voor update-on-change
    if (form) {
      form._onFormChanged();
    }

    var filterContainer = $('.select2__container');
    filterContainer.addClass('hidden');

    mountSelect2CustomFilters();

  });

  $('body').on('click', '.removable-facet a', function(){
    setTimeout(() => {
      mountSelect2CustomFilters();
    }, 1000);
  });
});

function mountSelect2CustomFilters(){
  $('.select2-custom-filters').select2();
}

// SEARCH SECTION
const SearchSection = class extends HTMLElement {
  connectedCallback() {
    console.log("SearchSection connected");
  }
};

if (!window.customElements.get("search-section")) {
  window.customElements.define("search-section", SearchSection);
}
// END SEARCH SECTION


function parseHTML(html, btnText) {
  // Open Select2 direct met loading state
  const select = document.querySelector('.select2-custom-filters');
  $(select).select2('open');
  $('.select2-dropdown').append('<div class="select2-loading">Loading...</div>');

  // Parse HTML en update filters
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const suitableForFilter = doc.querySelector('.checkbox-list.suitable-for');

  if (!suitableForFilter) {
    console.error("Geen 'Suitable for' filter gevonden!");
    $('.select2-loading').remove();
    return;
  }

  // Reset select options
  select.innerHTML = `<option value="">Select an option</option>`;

  // Update checkboxes en select options
  const checkboxes = suitableForFilter.querySelectorAll('.checkbox-container .checkbox');
  const filterForm = document.querySelector('.filter-form');
  const checkboxList = filterForm.querySelector('.checkbox-list.suitable-for');

  checkboxes.forEach(checkbox => {
    addCheckboxToForm(checkbox, checkboxList);
    addOptionToSelect(checkbox, select);
  });

  // Update Select2 met zoekopdracht
  setTimeout(() => {
    $('.select2-loading').remove();
    const select2Instance = $(select).data('select2');
    select2Instance.dropdown.$search.val(btnText).trigger('input');
  }, 100);
}

// Helper functies voor betere leesbaarheid
function addCheckboxToForm(checkbox, checkboxList) {
  const container = document.createElement('div');
  container.className = 'checkbox-container';
  
  const clonedCheckbox = checkbox.cloneNode(true);
  clonedCheckbox.id = `checkbox-${Math.random().toString(36).substr(2, 9)}`;
  
  const label = document.createElement('label');
  label.setAttribute('for', clonedCheckbox.id);
  label.textContent = `${checkbox.value} (${checkbox.nextElementSibling.textContent.match(/\((\d+)\)/)?.[1] || '0'})`;
  
  container.append(clonedCheckbox, label);
  checkboxList.appendChild(container);
}

function addOptionToSelect(checkbox, select) {
  const option = document.createElement('option');
  option.value = checkbox.value;
  option.textContent = checkbox.value;
  select.appendChild(option);
}

// Voeg CSS toe voor de loading indicator
const style = document.createElement('style');
style.textContent = `
  .select2-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    color: #666;
  }
  .select2-loading::after {
    content: '';
    width: 20px;
    height: 20px;
    margin-left: 10px;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #666;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(style);

// ... existing code ...